// extracted by mini-css-extract-plugin
module.exports = {"root":"EventDetailReview_root__RkQIP"};